/**
 * The canonical set of AI-voice speed steps. `value` is the multiplier stored on the
 * voiceover asset (`ai_voice_speed`) and sent to the backend; `displayRate` is the
 * perceived rate shown to users (it deliberately differs from `value`). Both the speed
 * selector UI (AIVoiceSpeed) and the agent's edit_ai_voiceover tool source their options
 * from here so the steps stay in one place.
 */
export type AIVoiceSpeedName = 'slowest' | 'slow' | 'normal' | 'fast' | 'fastest';

export interface AIVoiceSpeedOption {
    name: AIVoiceSpeedName;
    label: string;
    displayRate: string;
    value: number;
}

export const AI_VOICE_SPEED_OPTIONS: readonly AIVoiceSpeedOption[] = [
    { name: 'slowest', label: 'Slowest speed', displayRate: '0.5x', value: 0.75 },
    { name: 'slow', label: 'Slow speed', displayRate: '0.75x', value: 0.85 },
    { name: 'normal', label: 'Normal speed', displayRate: '1.0x', value: 1 },
    { name: 'fast', label: 'Fast speed', displayRate: '1.25x', value: 1.1 },
    { name: 'fastest', label: 'Fastest speed', displayRate: '1.5x', value: 1.2 },
];
